import { cn } from "@/lib/utils";

/**
 * Skeleton loading placeholder with shimmer animation.
 * Respects prefers-reduced-motion accessibility preference.
 */
// function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
//   return (
//     <div 
//       className={cn(
//         "relative overflow-hidden rounded-md bg-muted",
//         // Only animate shimmer if reduced motion is not preferred
//         "motion-safe:after:absolute motion-safe:after:inset-0 motion-safe:after:translate-x-[-100%] motion-safe:after:animate-shimmer",
//         "motion-safe:after:bg-gradient-to-r motion-safe:after:from-transparent motion-safe:after:via-white/20 motion-safe:after:to-transparent",
//         className
//       )} 
//       {...props} 
//     />
//   );
// }

// export { Skeleton };

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("cn-skeleton animate-pulse", className)}
      {...props}
    />
  )
}

export { Skeleton }
